module.exports = __webpack_public_path__ + "media/images/emblems/Trientwappen-83abd9daf16f136938ce0b607abea8e9.png";